import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2'
import Logo from '../../images/logo-fundemas.png'
import FormError from "../../components/FormError"
import ModalRecoveryPassword from "../../Modals/Modals.js"
import MainSectionLayout from "../../layout/MainSectionLayout";
import { Eye, EyeOff } from "lucide-react";
import {
    validateData,
    postOrPutRequest,
    encryptData
} from '../../utils/utils';

const RecoveryPassword = () => {
    const [formulario, setFormulario] = useState({
        email: '',
        password: '',
        password_confirmation: '',
    });

    const [alert, setAlert] = useState([
        {
            inputName: '',
            status: false,
            message: '',
        },
    ]);

    const navigate = useNavigate();

    const { token } = useParams();

    const sendData = async () => {
        let response = await postOrPutRequest(`auth/reset-password`, 'POST', {
            email: encryptData(formulario.email),
            token,
            password: encryptData(formulario.password),
            password_confirmation: encryptData(formulario.password_confirmation),
        });
        if (response.type === 'success') {
            Swal
                .fire({
                    title: 'Contraseña actualizada',
                    text: 'Contraseña actualizada correctamente',
                    icon: 'success',
                    confirmButtonText: 'Aceptar',
                    timer: 3000,
                })
                .then(() => {
                    navigate('/');
                });
        } else {
            Swal.fire({
                title: '¡Error!',
                text: response.message,
                icon: 'error',
                confirmButtonText: 'Aceptar',
            })
                .then(() => {
                    navigate('/');
                });
        }
    };

    const validateDataForm = (e) => {
        e.preventDefault();
        let inputs = Object.entries(formulario).map(([key, value]) => {
            return {
                name: key,
                value: value,
            };
        });
        const datosValidados = validateData(inputs);
        setAlert(datosValidados);
        let totalValidaciones = datosValidados
            .filter((input) => input.status !== false)
            .map(() => {
                return false;
            });

        if (totalValidaciones.length === 0) {
            if (formulario.password !== formulario.password_confirmation) {
                Swal.fire({
                    title: '¡Error!',
                    text: 'Las contraseñas no coinciden',
                    icon: 'error',
                    confirmButtonText: 'Aceptar',
                });
            } else {
                sendData();
            }
        }
    };

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setConfirmPassword] = useState(false);


    return (
        <MainSectionLayout>
            <form onSubmit={validateDataForm}>
                <h1 className="block text-sm sm:text-xl font-medium text-stone-700 dark:text-white">                  Cambio de contraseña
                </h1>
                <p className="mb-4 block font-normal text-xs text-stone-400 dark:text-stone-400">Por favor ingrese sus credenciales</p>
                <div className="mb-3">
                    <label className="mb-1 block font-medium text-sm md:text-sm text-slate-700 dark:text-white capitalize">
                        Correo electrónico
                    </label>
                    <div className="relative">
                        <input
                            type="email"
                            placeholder="Ingrese su correo electrónico"
                            className="w-full text-xs md:text-sm rounded-md border dark:border-stone-400 placeholder-stone-400 border-stroke bg-transparent py-3 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa dark:text-white focus-visible:shadow-none"
                            onChange={(e) =>
                                setFormulario({ ...formulario, email: e.target.value })
                            }
                            value={formulario.email}
                        />
                        {alert
                            .filter(
                                (input) =>
                                    input.inputName == 'email' && input.status === true,
                            )
                            .map((message, index) => (
                                <div key={index}>
                                    {' '}
                                    <span className="text-red-600 text-xs">{message.message}</span>
                                </div>
                            ))}
                    </div>
                </div>
                <div className="mb-3">
                    <label className="mb-1 block font-medium text-sm md:text-sm text-slate-700 dark:text-white">
                        Contraseña
                    </label>
                    <div className="relative">
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Ingrese su contraseña"
                            className="w-full text-xs md:text-sm rounded-md border border-stroke dark:border-stone-400 placeholder-stone-400 bg-transparent py-3 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa focus-visible:shadow-none dark:text-white"
                            onChange={(e) =>
                                setFormulario({
                                    ...formulario,
                                    password: e.target.value,
                                })
                            }
                            value={formulario.password}
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute bottom-3 right-11 flex items-center bg-white"
                        >
                            {showPassword ? <EyeOff className="w-5 h-5 md:w-6 md:h-6 text-gray-400" /> : <Eye className="w-5 h-5 md:w-6 md:h-6 text-gray-400" />}
                        </button>
                        {alert
                            .filter(
                                (input) =>
                                    input.inputName == 'password' &&
                                    input.status === true,
                            )
                            .map((message, index) => (
                                <div key={index}>
                                    {' '}
                                    <span className="text-red-600 text-xs">{message.message}</span>
                                </div>
                            ))}
                    </div>
                </div>
                <div className="mb-6">
                    <label className="mb-1 block font-medium text-sm md:text-sm text-slate-700 dark:text-white">
                        Confirmar contraseña
                    </label>
                    <div className="relative">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirme su contraseña"
                            className="w-full text-xs md:text-sm rounded-md border border-stroke dark:border-stone-400 placeholder-stone-400 bg-transparent py-3 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa focus-visible:shadow-none dark:text-white"
                            onChange={(e) =>
                                setFormulario({
                                    ...formulario,
                                    password_confirmation: e.target.value,
                                })
                            }
                            value={formulario.password_confirmation}
                        />
                        <button
                            type="button"
                            onClick={() => setConfirmPassword(!showConfirmPassword)}
                            className="absolute bottom-3 right-11 flex items-center bg-white"
                        >
                            {showConfirmPassword ? <EyeOff className="w-5 h-5 md:w-6 md:h-6 text-gray-400" /> : <Eye className="w-5 h-5 md:w-6 md:h-6 text-gray-400" />}
                        </button>
                        {alert
                            .filter(
                                (input) =>
                                    input.inputName == 'password_confirmation' &&
                                    input.status === true,
                            )
                            .map((message, index) => (
                                <div key={index}>
                                    {' '}
                                    <span className="text-red-600 text-xs">{message.message}</span>
                                </div>
                            ))}
                    </div>
                </div>

                <div className="mb-1">
                    <button
                        className="w-full text-sm md:text-sm font-medium cursor-pointer rounded-md border border-Turquesa dark:border-stone-400 placeholder-stone-400 bg-turquesa py-3 px-2 text-white transition hover:bg-opacity-90 capitalize"
                        type="submit"
                    >
                        Restablecer contraseña
                    </button>
                </div>
                {/* <div className="mt-2 mb-7 text-center text-sm text-stone-400">
          <br />
        </div> */}
            </form>
        </MainSectionLayout>
    );
};

export default RecoveryPassword;